/* eslint-disable @tanstack/query/exhaustive-deps -- doesn't work with keys factory */
import { useQuery } from "@tanstack/react-query";

import { sessionsKeys } from "../keys";
import { getSessions, type GetSessionsArgs } from "../requests";

export function useSessions(
  args: Omit<GetSessionsArgs, "tillId"> & { tillId: string | null }
) {
  return useQuery({
    queryKey: sessionsKeys.list({
      tillId: args.tillId ?? "unknown",
      start: args.options?.start,
      end: args.options?.end
    }),
    queryFn: () => getSessions({ ...args, tillId: args.tillId ?? "unknown" }),
    enabled: Boolean(args.tillId)
  });
}
